export default {
  title01: "Thời tiết hiện tại",
  title02: "24 tiếng",
  title03: "Xem dự báo thời tiết trong 10 ngày",
  title04: "AQI",
  title05: "Xem mọi thông tin",
  title06: "bình minh và hoàng hôn",
  title07: "pha Mặt Trăng",
  title08: "Trăng tròn kế tiếp",
  title09: "Trăng mới kế tiếp",
  title10: "Ngày",
  title11: "Đêm",
  title12: "Mặt Trời lên",
  title13: "Mặt Trời lặn",
  title14: "Lúc Trăng Lên",
  title15: "Lúc Trăng Lặn",
  title16: "nguồn",
  title17: "Bắt đầu",
  title18: "Kết thúc",
  title19: "sử dụng vị trí hiện tại",
  title20: "tìm thành phố",
  title21: "Nhiệt độ cảm nhận",
  title22: "Nhiệt độ cảm nhận (bóng râm)",
  title23: "Hiện tại",
  title24: "hôm nay",
  title25: "Chủ nhật",
  title26: "Thứ hai",
  title27: "Thứ ba",
  title28: "Thứ tư",
  title29: "Thứ năm",
  title30: "Thứ sáu",
  title31: "Thứ bảy",
  title32: "đang tải...",
  title33: "Hiện tại",
  title34: "Giờ",
  title35: "Hàng ngày",
  title36: "Mặt Trời và Mặt Trăng",
  title37: "Chất lượng không khí",
  title38: "Liên hệ tới : xlf550402@gmail.com",
  title39: "Thỏa thuận về quyền riêng tư",
  title40: " Bản quyền thuộc © comfortweather.com 2020 - 2026. Được bảo lưu mọi quyền.",
  title41: " Dữ liệu được cung cấp bởi",
  title42: "Nhiệt độ cao nhất",
  title43: "Nhiệt độ thấp nhất",
  title44: "Chấp nhận",
  title45: "Cảm ơn bạn đã sử dụng ComfortWeather! Để bảo vệ tốt hơn quyền lợi hợp pháp của bạn, vui lòng đọc kỹ ",
  title46: "Chính sách bảo mật",
  title47: " trước khi sử dụng.",
  title48: "",
  title49: "Liên hệ tới : xyjph123@gmail.com",
  title50: " Bản quyền thuộc © 24hweather.com 2020 - 2026. Được bảo lưu mọi quyền.",
  title51: "Cảm ơn bạn đã sử dụng 24hweather! Để bảo vệ tốt hơn quyền lợi hợp pháp của bạn, vui lòng đọc kỹ ",
  title52: "Vị trí của bạn đã thay đổi. Bạn có muốn cập nhật không?",
  title53: "Đồng ý",
  title54: "Huỷ",
  title55: "Trở lại",
  title56: "Tin tức",
  title57: "Đang cập nhật thời tiết",
  title58: "Thời tiết đã được cập nhật",
  title59: "Xem tất cả",
  title60: " Bản quyền thuộc © mobi321.com 2020 - 2026. Được bảo lưu mọi quyền.",
  title61: "Hôm qua",
  title62: "Ngày mai",
  title63: "xem dự báo thời tiết trong 15 ngày",
  title64: "Chi tiết hôm nay",
  title65: "Rahu Kaal",
  title66: "Chỉ số lối sống",
  title67: "Chỉ số lối sống",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Khó khô",
  title103: "Lâu khô",
  title104: "Dễ khô",
  title105: "Nhanh khô",
  title106: "Rất nhanh khô",

  title107: "Không phù hợp",
  title108: "Trải nghiệm ở mức vừa phải",
  title109: "Thích hợp cho các hoạt động dưới nước",
  title110: "Rất phù hợp",
  title111: "Điều kiện lý tưởng",

  title112: "Có lợi cho sức khỏe",
  title113: "Điều kiện bình thường",
  title114: "Nguy cơ tăng nhẹ",
  title115: "Nguy cơ cao",
  title116: "Mức nguy cơ cực kỳ cao",

  title117: "Không phù hợp",
  title118: "Tương đối phù hợp",
  title119: "Phù hợp cho hoạt động ngoài trời",
  title120: "Rất phù hợp",
  title121: "Điều kiện lý tưởng",

  title122: "Điều kiện rất khô",
  title123: "Có khả năng khô",
  title124: "Khô nhẹ",
  title125: "Ít khả năng khô",
  title126: "Rất ít khả năng khô",

  title127: "#",
  title128: "Có thể chấp nhận",
  title129: "Ngày thuận lợi",
  title130: "Điều kiện rất thuận lợi",
  title131: "Điều kiện lý tưởng",
};
